import { useFooterContact } from './useFooterContact';
import { FRESH_CX_PHONE } from '@farmersdog/constants/phoneNumbers';

export const useSupportLinks = () => {
  const { showPhone, showEmail, supportEmail } = useFooterContact();

  const supportEmailLink = {
    label: supportEmail,
    href: `mailto:${supportEmail}`,
  };
  const supportPhoneLink = {
    label: `Call or Text ${FRESH_CX_PHONE.display}`,
    href: `tel:${FRESH_CX_PHONE.link}`,
  };

  return [
    ...(showEmail ? [supportEmailLink] : []), // only show if email is available
    ...(showPhone ? [supportPhoneLink] : []), // only show if phone is available
  ];
};
